import {Block, Col} from 'jsxstyle'
import i18n from '../../../common/i18n'
import React from 'react'

const XpertKnowledgeTutorialNotFound: React.FC = () => {
  return (
    <Col height="100vh" alignItems="center" gap="16px" padding="20px" marginTop="30px">
      <Block fontSize="24px" fontWeight="bold">
        {i18n.t('xk.tutorial.notFoundTitle')}
      </Block>
      <Block fontSize="16px">{i18n.t('xk.tutorial.notFoundSubTitle')}</Block>
    </Col>
  )
}

export default XpertKnowledgeTutorialNotFound
